module.exports = __webpack_public_path__ + "static/media/ellipsis-v.bf55a529.svg";